import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { useState } from "react";
import Cards from "react-credit-cards";
import "react-credit-cards/lib/styles.scss";
import { toast } from "react-toastify";
import { usePrivate } from "../context/PrivateInfoContext";


function BandeiraCartaoDialog({close,selecionarBandeira}){
 const {cartaoBandeira,setCartaoBandeira,cartaoNumero,setCartaoNumero} = usePrivate()
 const [cartaoNome] = useState('');
 const [cartaoVencimento] = useState('');
 const [campoFoco,setCampoFoco] = useState('');

 const bandeiras = [
    {
        value:'mastercard',
        label:'MasterCard',
    },
    {
        value:'elo',
        label:'Elo',
    },
    {
        value:'visa',
        label:'VISA',
    },
 ]


 const defineBandeira = (cardData) =>{
    cardData.preventDefault()
    selecionarBandeira(cartaoBandeira)
    console.log(cardData)
 }


    return (
    <Dialog
    visible
    header="Bandeira do Cartão"
    onHide={()=>close()}
    style={{
        minHeigth:'30vw', 
        minWidth: '20vw', 
        textAlign: 'center', 
        borderRadius: "0.75rem",
    }}
    draggable={false} 
    className="boletosDialog"
    >
        <div className="grid p-1 text-left">
            <div>
                <Cards
                //cvc={cartaoCVC}
                acceptedCards={['visa','mastercard','elo']}
                callback={(type)=>{cartaoNumero && setCartaoBandeira(type.issuer)}}
                expiry={cartaoVencimento}
                name={cartaoNome}
                number={cartaoNumero}
                focused={campoFoco}
                placeholders={{ name: "NOME" }}
                locale={{ valid: "Válido até" }}
                />
            </div>
            <form onSubmit={e=>defineBandeira(e)} onInvalid={(e)=>toast.warning('Bandeira ainda não aceita')} >
            <div className="flex flex-col mt-4 font-bold gap-2">
                <div className="flex flex-col">
                    <label>Selecione a bandeira do Cartão</label>
                    <Dropdown
                    value={cartaoBandeira}
                    options={bandeiras}
                    emptyMessage="Bandeira não aceita no momento"
                    
                    required
                    onChange={(e)=>{setCartaoNumero('');setCartaoBandeira(e.value)}}
                    />
                </div>
                <div className="text-center">
                    <h5>OU</h5>
                </div>
                <div className="flex flex-col">
                    <label>Digite o número do Cartão</label>
                    <InputMask
                    name="number"
                    value={cartaoNumero}
                    onFocus={e=>{setCampoFoco(e.target.name)}}
                    onChange={e=>setCartaoNumero(e.value)}
                    placeholder="ex: 9999 9999 9999 9999"
                    mask="9999 9999 9999 9999"
                    //tooltipOptions={}
                    unmask
                    />
                </div>
                <div className="paymentButton mt-2">
                    <Button label="Escolher" type="submit" />
                </div>
            </div>
            </form>
        </div>

    </Dialog>
)
}

export default BandeiraCartaoDialog